import React from "react"
import { Button, Col, Container, Row } from "react-bootstrap"
import withHooks from "../../Common/jsx/WithHooks"
import { Flower1 } from "react-bootstrap-icons"

class Splash extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    this.dMgr.activate(true)
    this.dMgr.debug("const_props:", this.props)

    this.state = { isReadyToRender: true }

    this.dMgr.debug("init_state:", this.state)
  }

  componentDidMount() {
    // this.getEntities()
  }

  render() {
    if (!this.state.isReadyToRender) {
      this.dMgr.debug("render:", "not ready")
      return null
    }
    this.dMgr.rendering()

    let toRender = (
      <>
        <Row className="text-center">
          <Col className="background-color-black padding-bottom-15 padding-top-15">
            <h1 className="color1">Green Garden</h1>
            <h3 className="color2" title="Gibran Khalil">
              Un jardin est un poème que la terre écrit pour le ciel
            </h3>
          </Col>
        </Row>
        <Row className="margin-top-50">
          <Col md={12} className="text-center ">
            <Button
              className="width-100 button-color1 margin-left-8 margin-top-8 color2 font-weight-bold"
              onMouseOver={() => {
                this.props.changeLanguage("fr")
              }}
              onClick={() => {
                this.props.router.nav({ url: "/plants" })
              }}
            >
              Entrer
            </Button>
          </Col>
        </Row>
      </>
    )

    this.dMgr.renderDone()
    return toRender
  }
}
export default withHooks(Splash)
